import React from 'react'
import PropTypes from 'prop-types'

import { CtaLabel } from 'components/Typography'
import { BoxedItem } from 'styles/sharedStyle'

import { Button, ListWrapper, Wrapper } from './QuickNav.style'

const OPTIONS = [
  'ALL',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  '#',
]

const QuickNav = ({
  currentLetter,
  entries,
  filteredBrands,
  handleShowLetter,
}) => (
  <Wrapper>
    <ListWrapper>
      {OPTIONS.map((item) => (
        <BoxedItem key={item}>
          <Button
            disabled={
              (item !== 'ALL' && entries.indexOf(item) < 0) ||
              (filteredBrands[item] && filteredBrands[item].length < 1)
            }
            type="button"
            isActive={item === currentLetter}
            onClick={() => handleShowLetter(item)}>
            <CtaLabel>{item}</CtaLabel>
          </Button>
        </BoxedItem>
      ))}
    </ListWrapper>
  </Wrapper>
)

QuickNav.propTypes = {
  currentLetter: PropTypes.string.isRequired,
  entries: PropTypes.arrayOf(PropTypes.string).isRequired,
  filteredBrands: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.array]))
    .isRequired,
  handleShowLetter: PropTypes.func.isRequired,
}

export default QuickNav
